module.exports = __webpack_public_path__ + "img/image3.25cb5fe6.webp";